import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { Typography, Box } from '@mui/material';
import { GET_METADADOS_ETL } from '../../../requests/graphql';
import { useQuery } from '@apollo/client';
import Description from './Description';
import { FormatDate } from '@datatox-bi/util';

const MyTypography = styled(Typography)({
    marginLeft: 'auto',
    fontSize: '1.2rem',
    fontWeight: 'bold',
});

const formatDtUltimoProcessamento = (data) => {
    if (!data || !data['iMetaETL']) return null;

    const { dtInicioProcessamento, tipo, dtProcessado, dtUltimoRegistro, statusPorcentagem } = data['iMetaETL'];

    // Montagem do título principal
    const terminoUltimoProcessamento = dtProcessado || dtInicioProcessamento;
    const formatTerminoUltimoProcessamento = FormatDate.formatDataHora(terminoUltimoProcessamento);
    const resultTerminoUltimoProcessamento = `Atualizado: ${formatTerminoUltimoProcessamento}`;

    // Montagem das informações do Tooltip
    let resultProcessamento, resultUltimoRegistro, resultTipoProcessamento, resultDataInicioProcessamento;
    if (dtInicioProcessamento) resultDataInicioProcessamento = `Data de início do processamento: ${FormatDate.formatDataHora(dtInicioProcessamento)}`;
    if (dtProcessado && statusPorcentagem) resultProcessamento = `Data processada: ${FormatDate.formatDataHora(dtProcessado)} (${statusPorcentagem}%)`;
    if (dtUltimoRegistro) resultUltimoRegistro = `Data do último registro: ${FormatDate.formatDataHora(dtUltimoRegistro)}`;
    if (tipo) resultTipoProcessamento = `Tipo de processamento: ${tipo}`;

    // @TODO por enquanto, está informação está fixada.
    const resultFrequenciaAtualizacao = "Frequência de atualização: diária";

    return { resultFrequenciaAtualizacao, resultTerminoUltimoProcessamento, resultProcessamento, resultUltimoRegistro, resultTipoProcessamento, resultDataInicioProcessamento };
}

const TitleCube = ({ title, cubo = "" }) => {
    const { loading, error, data } = useQuery(GET_METADADOS_ETL, {
        fetchPolicy: 'no-cache', variables: {
            cubo
        },
        skip: cubo === ""
    });

    let renderInfo = <></>;
    if (loading) renderInfo = <MyTypography variant="h6" component="h6">Carregando...</MyTypography>;
    else if (error) renderInfo = <MyTypography variant="h6" component="h6">Ocorreu um erro ao carregar os dados.</MyTypography>;
    else {
        const res = formatDtUltimoProcessamento(data);
        renderInfo = (res && <>
            <MyTypography variant="h6" component="h6">
                {res.resultTerminoUltimoProcessamento}
                <Description>
                    {res.resultFrequenciaAtualizacao && <>{res.resultFrequenciaAtualizacao} <br /></>}
                    {res.resultTipoProcessamento && <>{res.resultTipoProcessamento} <br /></>}
                    {res.resultDataInicioProcessamento && <>{res.resultDataInicioProcessamento} <br /></>}
                    {res.resultProcessamento && <>{res.resultProcessamento} <br /></>}
                    {res.resultUltimoRegistro && <>{res.resultUltimoRegistro} <br /></>}
                </Description>
            </MyTypography>
        </>);
    }

    return (
        <Box display="flex">
            <Typography variant="h4" color='primary' >
                {title}
            </Typography>
            {renderInfo}
        </Box>
    );
};

TitleCube.propTypes = {
    title: PropTypes.string,
    cubo: PropTypes.string,
};

export default TitleCube;
